import {
  formatDateTime,
  formatRelativeTime,
  isRecent,
} from "@/shared/datetime";

/** "Verified 3 minutes ago" within a day of `timestamp`, else "Verified <date and time>". */
export function verifiedAgo(timestamp: string): string {
  return isRecent(timestamp)
    ? `Verified ${formatRelativeTime(timestamp)}`
    : `Verified ${formatDateTime(timestamp)}`;
}
